import { createContext, useState, useEffect, useContext, useMemo } from 'react';
import {
  getClients,
  postClient,
  putClient
} from '../service/serviceChat/clientsService';
import {
  getNewCustomer,
  getMyCustomer,
  getFullCustomer,
  getMotivation,
  postCustomer,
  transferCustomer
} from '../service/serviceChat/customerService';
import {
  getWaitingRoom
} from '../service/serviceChat/waitingRoom';
import { eventsUsers } from '../service/serviceChat/chatService';
import { getMyChatsInGroup, getTagsGroup } from '../service/serviceChat/groupService';
import { useAuth, GroupDefault } from './auth';
import { useNotification } from './notification';

const keyIdChatStorage = '@UCB-IdChat';
const keyNameClientInChatStorage = '@UCB-NameClient';
const keyRenderStorage = '@UCB-Render';
const keyOrderListStorage = '@UCB-OrderList';
const keyCustomerStorage = '@UCB-Customer';
const keyMyChatsOpenStorage = '@UCB-MyChatsOpen';
const keyMyChatsGroupStorage = '@UCB-MyChatsGroup';
const keyFullChatsOpenStorage = '@UCB-FullChatsOpen';

const ChatContext = createContext();


export const ChatProvider = ({ children }) => {

  const {
    idUser,
    accessLevel,
    loadingAccessLevel,
    functionality
  } = useAuth();

  const {
    handlerContNewChats,
    handlerContMyChats,
    handlerContOpenChats,
    handlerContMyGroup,
  } = useNotification();

  const [idChat, setIdChat] = useState(null);
  const [nameClientInChat, setNameClientInChat] = useState(
    sessionStorage.getItem(keyNameClientInChatStorage) || null
  );
  const [render, setRender] = useState(
    sessionStorage.getItem(keyRenderStorage) || 0
  );
  const [orderList, setOrderList] = useState(1);
  const [customer, setCustomer] = useState(
    sessionStorage.getItem(keyCustomerStorage) || null
  );
  const [waitingRoom, setWaitingRoom] = useState([]);
  const [newChats, setNewChats] = useState([]);
  const [myChatsOpen, setMyChatsOpen] = useState(
    sessionStorage.getItem(keyMyChatsOpenStorage) || []
  );
  const [myChatsClose, setMyChatsClose] = useState([]);
  const [myChatsGroup, setMyChatsGroup] = useState(
    sessionStorage.getItem(keyMyChatsGroupStorage) || []
  );
  const [fullChatsOpen, setFullChatsOpen] = useState(
    sessionStorage.getItem(keyFullChatsOpenStorage) || []
  );
  const [textSearch, setTextSearch] = useState('');
  const [myTagsGroup, setMyTagsGroup] = useState([])


  const onSelectedTabList = () => {
    const path = window.location.pathname;
    if (accessLevel?.includes('ADMINISTRADOR')) {
      if (path.includes('/admin/')) {
        setOrderList(6);
        return
      }
    }
    if (accessLevel?.includes('RELATORIOS')) {
      if (path.includes('/reports/')) {
        setOrderList(7);
        return
      }
    }
    setOrderList(1);
  }
  useEffect(() => {
    if (accessLevel?.length === 0) return
    onSelectedTabList();
    if (idUser) {
      eventsUsers([idUser], events);
    }
    if (GroupDefault()) {
      eventsUsers([GroupDefault()?.toString()], events);
    }
  }, [accessLevel]);

  function events(type) {
    switch (type) {
      case 'CUSTOMER_SERVICE - NOVOS':
        handleNewChats(true)
        break
      case 'CUSTOMER_SERVICE':
        handleMyChats(true);
        handleMyGroup(true);
        break
      case 'CUSTOMER_SERVICE_SALA':
        onSearchWaitingRoom(true);
        handleMyGroup(true);
        break
    };
  };

  async function handleNewChats(isEvent) {
    if (!idUser) return
    const chats = await getNewCustomer();
    handlerContNewChats(chats?.length);
    setNewChats([...chats])
    return
  };
  async function handleMyChats(isEvent) {
    if (!idUser) return
    const chats = await getMyCustomer(idUser)
    handlerContMyChats(chats?.length)
    setMyChatsOpen([...chats])
    return
  };
  async function handleFullChats() {
    if (!idUser) return
    const chats = await getFullCustomer()
    handlerContOpenChats(chats?.length)
    setFullChatsOpen([...chats])
    return
  };
  async function handleMyGroup(isEvent) {
    if (!idUser) return
    const [respGroups, respTags] = await Promise.all([
      getMyChatsInGroup(idUser),
      getTagsGroup(idUser)
    ])

    const qtd = respGroups.reduce((acc, item) => {
      return acc + (item.customer_services?.length ?? 0);
    }, 0);
    handlerContMyGroup(qtd)
    setMyChatsGroup([...respGroups])
    setMyTagsGroup([...respTags?.sort()])
    return
  };
  const waitingRoomLength = useMemo(() => waitingRoom.length, [waitingRoom]);
  async function onSearchWaitingRoom(isEvent) {
    if (!accessLevel?.includes('SALA_ESPERA')) return
    const response = await getWaitingRoom();
    setWaitingRoom([...response])
  }


  function onOpenView(data) {
    setCustomer(data)
    sessionStorage.setItem(keyCustomerStorage, JSON.stringify(data));
    setIdChat(data?.client_phone)
    sessionStorage.setItem(keyIdChatStorage, data?.client_phone);
    setNameClientInChat(data?.name_client)
    sessionStorage.setItem(keyNameClientInChatStorage, data?.name_client);
    setRender(1)
    sessionStorage.setItem(keyRenderStorage, 1);
  };
  function handOpenView(data) {
    setCustomer(data)
    sessionStorage.setItem(keyCustomerStorage, JSON.stringify(data));
    setIdChat(data.client_phone)
    sessionStorage.setItem(keyIdChatStorage, data.client_phone);
    setNameClientInChat(data.client_name)
    sessionStorage.setItem(keyNameClientInChatStorage, data.client_name);
    setRender(1)
    sessionStorage.setItem(keyRenderStorage, 1);
  };
  function handOpenPreview(data, nameClient, renderNumber) {
    setCustomer(data)
    sessionStorage.setItem(keyCustomerStorage, JSON.stringify(data));

    setIdChat(data.client_phone)
    sessionStorage.setItem(keyIdChatStorage, data.client_phone);

    setNameClientInChat(nameClient)
    sessionStorage.setItem(keyNameClientInChatStorage, nameClient);

    setRender(renderNumber)
    sessionStorage.setItem(keyRenderStorage, renderNumber);
  };
  async function UpdateNameClient(new_name, number_client, number_key) {
    const client = await getClients(number_client, number_key);
    if (client) {
      const success = putClient(client.id, new_name, number_client, number_key);
      if (!success) return
      if (number_client !== idChat) return success
      sessionStorage.setItem(keyNameClientInChatStorage, new_name);
      setNameClientInChat(new_name);
      return success
    } else {
      const success = await postClient(new_name, number_client, number_key)
      if (!success) return
      if (number_client !== idChat) return success
      sessionStorage.setItem(keyNameClientInChatStorage, new_name);
      setNameClientInChat(new_name);
      return success
    }
  };
  function SelectOrderList(value) {
    setOrderList(value)
    sessionStorage.setItem(keyOrderListStorage, value);
  };
  function SelectRender(value) {
    setRender(value)
    sessionStorage.setItem(keyRenderStorage, value);
  };
  function reload() { };

  async function onNewCustomer(customer, selectTab) {
    const response = await postCustomer(customer?.client_id, idUser, true);
    if (!response) return 'error';
    if (response?.status === 'clone') return { status: 'clone', customerServiceOpen: response?.customerServiceOpen };
    let aux = response.typeWindow = 3;
    if (selectTab) {
      handOpenView(aux);
      SelectOrderList(1);
    }
    resetChat();
  };
  async function onTransferCustomerByMy(dataCustomer, verificationCustomerOpen, selectTab) {
    const motivation = await getMotivation()
    let idMotivation = 0;
    for (let i in motivation) {
      if (motivation[i].tag === "PADRAO") idMotivation = motivation[i].id;
    };
    const response = await transferCustomer(
      dataCustomer,
      ' ',
      idUser,
      idMotivation,
      verificationCustomerOpen
    );
    if (!response) return 'error';
    if (response?.status === 'clone') return {
      status: 'clone',
      customerServiceOpen: response?.customerServiceOpen
    };
    let aux = response?.customerservice
    aux.typeWindow = 3
    if (selectTab) {
      handOpenView(aux);
      SelectOrderList(1);
    }
    resetChat();
  };
  function resetChat() {
    setCustomer(null)
    sessionStorage.setItem(keyCustomerStorage, '');
    setIdChat('')
    sessionStorage.setItem(keyIdChatStorage, '');
    setNameClientInChat('')
    sessionStorage.setItem(keyNameClientInChatStorage, '');
  }
  function onFilter(item, order) {
    if (order !== orderList) return item
    const { client_name, client_phone } = item;
    const regex = new RegExp(textSearch, 'i');
    return regex?.test(client_name) || regex?.test(client_phone);
  };

  const chatValues = {
    idUser,
    nameClientInChat,
    idChat,
    render,
    setCustomer,
    customer,
    orderList,
    newChats,
    myChatsOpen,
    fullChatsOpen,
    myChatsClose,
    myChatsGroup,
    accessLevel,
    loadingAccessLevel,
    functionality,
    textSearch,
    myTagsGroup,
    onOpenView,
    onSearchWaitingRoom,
    waitingRoomLength,
    waitingRoom,
    handleNewChats,//
    handleMyChats,//
    handleFullChats,//
    handOpenPreview,
    handOpenView,
    handleMyGroup,//
    UpdateNameClient,
    SelectOrderList,
    SelectRender,
    resetChat,
    reload,
    onNewCustomer,
    onTransferCustomerByMy,
    setMyChatsClose,
    setTextSearch,
    onFilter
  };

  return (
    <ChatContext.Provider value={chatValues}>{children}</ChatContext.Provider>
  );
};

export function useChat() {
  const context = useContext(ChatContext);
  return context;
}

export const IdChatOpen = () => sessionStorage.getItem(keyIdChatStorage);

export const Customer = () => sessionStorage.getItem(keyCustomerStorage);